import { Injectable } from '@angular/core';
// import { Chart } from '../../../assets/js/admin/Chart.bundle.min.js';

declare const $: any;
declare const Chart: any;
declare const moment: any;
declare const jQuery: any;
const $body = jQuery('body');
const $window = jQuery(window);

function menuHideExtraElements() {

  jQuery('.sf-more-li, .sf-logo-li').remove();
  const windowWidth = jQuery('body').innerWidth();

  jQuery('.sf-menu').each(function() {
    const $thisMenu = jQuery(this);
    const $menuWraper = $thisMenu.closest('.mainmenu_wrapper');
    $menuWraper.attr('style', '');
    if (windowWidth > 991) {
      const $menuLis = $menuWraper.find('.sf-menu > li');
      $menuLis.removeClass('sf-md-hidden');

      const $headerLogoCenter = $thisMenu.closest('.header_logo_center');
      let logoWidth = 0;
      let summaryLiWidth = 0;

      if ($headerLogoCenter.length) {
        const $logo = $headerLogoCenter.find('.logo');
        // 30/2 - left and right margins
        logoWidth = $logo.outerWidth(true) + 70;
      }

      // const wrapperWidth = jQuery('.sf-menu').width();
      const wrapperWidth = $menuWraper.outerWidth(true);
      $menuLis.each(function(index) {
        const elementWidth = jQuery(this).outerWidth();
        summaryLiWidth += elementWidth;
        if (summaryLiWidth >= (wrapperWidth - logoWidth)) {
          const $newLi = jQuery('<li class="sf-more-li"><a>...</a><ul></ul></li>');
          jQuery($menuLis[index - 1]).before($newLi);
          const newLiWidth = jQuery($newLi).outerWidth(true);
          const $extraLiElements = $menuLis.filter(':gt(' + (index - 2) + ')');
          $extraLiElements.clone().appendTo($newLi.find('ul'));
          $extraLiElements.addClass('sf-md-hidden');
          return false;
        }
      });

      if ($headerLogoCenter.length) {
        const $menuLisVisible = $headerLogoCenter.find('.sf-menu > li:not(.sf-md-hidden)');
        const menuLength = $menuLisVisible.length;
        let summaryLiVisibleWidth = 0;
        $menuLisVisible.each(function() {
          summaryLiVisibleWidth += jQuery(this).outerWidth();
        });

        let centerLi = Math.floor(menuLength / 2);
        if ((menuLength % 2 === 0)) {
          centerLi--;
        }
        const $liLeftFromLogo = $menuLisVisible.eq(centerLi);
        $liLeftFromLogo.after('<li class="sf-logo-li"></li>');
        $headerLogoCenter.find('.sf-logo-li').width(logoWidth);
        const liLeftRightDotX = $liLeftFromLogo.offset().left + $liLeftFromLogo.outerWidth();
        const logoLeftDotX = windowWidth / 2 - logoWidth / 2;
        const menuLeftOffset = liLeftRightDotX - logoLeftDotX;
        $menuWraper.css({left: -menuLeftOffset});
      }

    }// > 991
  });
}
function initMegaMenu() {
  const $megaMenu = jQuery('.mainmenu_wrapper .mega-menu');
  if ($megaMenu.length) {
    const windowWidth = jQuery('body').innerWidth();
    if (windowWidth > 991) {
      $megaMenu.each(function() {
        const $thisMegaMenu = jQuery(this);
        $thisMegaMenu.css({display: 'block', left: 'auto'});
        const thisWidth = $thisMegaMenu.outerWidth();
        const thisOffset = $thisMegaMenu.offset().left;
        const thisLeft = (thisOffset + (thisWidth / 2)) - windowWidth / 2;
        $thisMegaMenu.css({left : -thisLeft, display: 'none'});
        if (!$thisMegaMenu.closest('ul').hasClass('nav')) {
          $thisMegaMenu.css('left', '');
        }
      });
    }
  }
}
function  affixSidebarInit() {
  const $affixAside = jQuery('.affix-aside');
  if ($affixAside.length) {

    $affixAside.on('affix.bs.affix', (e) => {
      const affixWidth = $affixAside.width() - 1;
      const affixLeft = $affixAside.offset().left;
      $affixAside
        .width(affixWidth)
        .css('left', affixLeft);
    }).on('affix-top.bs.affix affix-bottom.bs.affix', (e) => {
      $affixAside.css({width: '', left: ''});
    });

    let offsetTop = $affixAside.offset().top - jQuery('.page_header').height();
    let offsetBottom = jQuery('.page_footer').outerHeight(true) + jQuery('.page_copyright').outerHeight(true);

    $affixAside.affix({
      offset: {
        top: offsetTop,
        bottom: offsetBottom
      },
    });

    jQuery(window).on('resize', () => {
      $affixAside.css({width: '', left: ''});

      if ( $affixAside.hasClass('affix')) {
        $affixAside.removeClass('affix').css('left', '').addClass('affix-top');
      }

      offsetTop = jQuery('.page_topline').outerHeight(true)
        + jQuery('.page_toplogo').outerHeight(true)
        + jQuery('.page_header').outerHeight(true)
        + jQuery('.page_breadcrumbs').outerHeight(true)
        + jQuery('.blog_slider').outerHeight(true);
      offsetBottom = jQuery('.page_footer').outerHeight(true)
        + jQuery('.page_copyright').outerHeight(true);

      $affixAside.data('bs.affix').options.offset.top = offsetTop;
      $affixAside.data('bs.affix').options.offset.bottom = offsetBottom;

      $affixAside.affix('checkPosition');

    });

  }
}
function initAnimateElement(self, index) {
  const animationClass = !self.data('animation') ? 'fadeInUp' : self.data('animation');
  const animationDelay = !self.data('delay') ? 150 : self.data('delay');
  setTimeout(() => {
    self.addClass('animated ' + animationClass);
  }, index * animationDelay);
}
function initCounter(self) {
  if (self.hasClass('counted')) {
    return;
  } else {
    self.countTo().addClass('counted');
  }
}
function  initProgressbar(el) {
  el.progressbar({
    transition_delay: 300
  });
}
function initChart(el) {
  const data = el.data();
  const newSize = data.size ? data.size : 270;
  const line = data.line ? data.line : 20;
  const bgcolor = data.bgcolor ? data.bgcolor : '#ffffff';
  const trackcolor = data.trackcolor ? data.trackcolor : '#c14240';
  const speed = data.speed ? data.speed : 3000;

  el.easyPieChart({
    barColor: trackcolor,
    trackColor: bgcolor,
    scaleColor: false,
    scaleLength: false,
    lineCap: 'butt',
    lineWidth: line,
    size: newSize,
    rotate: 0,
    animate: speed,
    onStep(from, to, percent) {
      jQuery(this.el).find('.percent').text(Math.round(percent));
    }
  });
}
function initOtherChart() {

  Chart.defaults.global.defaultFontColor = '#666666';
  Chart.defaults.global.defaultFontFamily = 'Poppins, Arial, sans-serif';
  Chart.defaults.global.defaultFontSize = 12;
  Chart.defaults.global.maintainAspectRatio = false;

  Chart.defaults.global.legend.labels.usePointStyle = true;

  Chart.defaults.scale.gridLines.color = 'rgba(100,100,100,0.15)';
  Chart.defaults.scale.gridLines.zeroLineColor = 'rgba(100,100,100,0.15)';
  // Chart.defaults.scale.gridLines.drawTicks = false;

  // Chart.defaults.scale.ticks.min = 0;
  Chart.defaults.scale.ticks.beginAtZero = true;
  Chart.defaults.scale.ticks.maxRotation = 0;

  Chart.defaults.scale.ticks.padding = 3;
  Chart.defaults.scale.ticks.autoSkipPadding = 10;

  Chart.defaults.global.elements.point.radius = 5;
  Chart.defaults.global.elements.point.borderColor = 'transparent';


  Chart.pluginService.register({
    beforeDraw:  (chart, easing) => {
      if (chart.config.options.chartArea && chart.config.options.chartArea.backgroundColor) {
        const ctx = chart.chart.ctx;
        const chartArea = chart.chartArea;
        ctx.save();
        ctx.fillStyle = chart.config.options.chartArea.backgroundColor;
        ctx.fillRect(chartArea.left, chartArea.top, chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        ctx.restore();
      }
    }
  });


  const DAYS = [
    '01.03',
    '06.03',
    '11.03',
    '16.03',
    '21.03',
    '26.03',
    '31.03'
  ];

  const MONTHS = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ];

  const MONTHS_HALF = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
  ];

  // New and Returned visitors
  let $canvasesMonthlyVisitors = jQuery('.canvas-chart-line-new-returned-visitors');
  if ($canvasesMonthlyVisitors.length) {
    $canvasesMonthlyVisitors.each(function(i) {

      const config = {
        type: 'line',
        data: {
          labels: MONTHS_HALF,
          datasets: [{
            label: 'New Visitors',
            // line options
            backgroundColor: 'rgba(77, 177, 158, 0.2)',
            borderColor: 'rgba(77, 177, 158, 1)',
            borderWidth: 2,
            fill: true,
            // point options
            pointBorderColor: 'transparent',
            pointBackgroundColor: 'transparent',
            pointBorderWidth: 0,
            // visitors per month
            data: [

              26,
              43,
              23,
              45,
              43,
              37,
              50,

            ],
          },
            {
              label: 'Returned Visitors',
              backgroundColor: 'rgba(0, 126, 189, 0.2)',
              borderColor: 'rgba(0, 126, 189, 1)',
              borderWidth: 2,
              fill: true,
              // point options
              pointBorderColor: 'transparent',
              pointBackgroundColor: 'transparent',
              pointBorderWidth: 0,
              // returned visitors per month
              data: [

                22,
                18,
                45,
                22,
                18,
                26,
                20,

              ],
            },
            // put new dataset here if needed to show multiple datasets on one graph
          ]
        },
        options: {
          chartArea: {
            backgroundColor: 'rgba(100, 100, 100, 0.02)',
          },
          scales: {
            yAxes: [{
              ticks: {
                maxTicksLimit: 4
              }
            }]
          }
        }
      };

      const canvas = jQuery(this)[0].getContext('2d');
      // tslint:disable-next-line:no-unused-expression
            // tslint:disable-next-line:no-unused-expression
      new Chart(canvas, config);
    });
  } // New and Returned visitors

  // Yearly visitors
  const $canvasesYearlyVisitors = jQuery('.canvas-chart-line-yearly-visitors');
  if ($canvasesYearlyVisitors.length) {
    $canvasesYearlyVisitors.each(function(i) {
      const config = {
        type: 'line',
        data: {
          labels: MONTHS_HALF,
          datasets: [{
            label: 'Unique Visitors',
            backgroundColor: 'rgba(77, 177, 158, 0.5)',
            borderColor: 'rgba(77, 177, 158, 0.5)',
            borderWidth: '0',
            // point options
            pointBorderColor: 'transparent',
            pointBackgroundColor: 'rgba(77, 177, 158, 1)',
            pointBorderWidth: 0,
            tension: '0',
            // visitors per month
            data: [300, 250, 480, 500, 300, 700, 900],
            fill: true,
          },
            // put new dataset here if needed to show multiple datasets on one graph
          ]
        },
        options: {
          chartArea: {
            backgroundColor: 'rgba(100, 100, 100, 0.02)',
          },

        }
      };

      const canvas = jQuery(this)[0].getContext('2d');
      // tslint:disable-next-line:no-unused-expression
            // tslint:disable-next-line:no-unused-expression
      new Chart(canvas, config);
    });
  } // Yearly visitors

  // Monthly visitors
  $canvasesMonthlyVisitors = jQuery('.canvas-chart-line-monthly-visitors');
  if ($canvasesMonthlyVisitors.length) {
    $canvasesMonthlyVisitors.each(function(i) {

      const config = {
        type: 'line',
        data: {
          labels: DAYS,
          datasets: [{
            label: 'Unique Visitors',
            backgroundColor: 'rgba(236, 104, 46, 0.5)',
            borderColor: 'rgba(236, 104, 46, 0.5)',
            borderWidth: '0',

            // point options
            pointBorderColor: 'transparent',
            pointBackgroundColor: 'rgba(236, 104, 46, 1)',
            pointBorderWidth: 0,

            tension: '0',
            // visitors per month
            data: [

              446,
              243,
              544,
              645,
              443,
              437,
              750,

            ],
            fill: true,
          },
            // put new dataset here if needed to show multiple datasets on one graph
          ]
        },
        options: {
          chartArea: {
            backgroundColor: 'rgba(100, 100, 100, 0.02)',
          },
        }
      };

      const canvas = jQuery(this)[0].getContext('2d');
      // tslint:disable-next-line:no-unused-expression
            // tslint:disable-next-line:no-unused-expression
      new Chart(canvas, config);
    });
  } // Monthly visitors

  // Monthly visitors with sells
  $canvasesMonthlyVisitors = jQuery('.canvas-chart-line-visitors-sels');
  if ($canvasesMonthlyVisitors.length) {
    $canvasesMonthlyVisitors.each(function(i) {

      const config = {
        type: 'line',
        data: {
          labels: DAYS,
          datasets: [{
            label: 'Visitors',
            backgroundColor: 'rgba(236, 104, 46, 0.5)',
            borderColor: 'rgba(236, 104, 46, 0.5)',
            borderWidth: 3,

            // point options
            pointBorderColor: 'transparent',
            pointBackgroundColor: 'rgba(236, 104, 46, 1)',
            pointBorderWidth: 0,

            tension: '0',
            // visitors per month
            data: [

              46,
              43,
              34,
              45,
              43,
              37,
              50,

            ],
            fill: false,
          },
            {
              label: 'Sells',
              backgroundColor: 'rgba(111, 211, 227, 0.6)',
              borderColor: 'rgba(91, 173, 186, 0.5)',
              borderWidth: 3,

              // point options
              pointBorderColor: 'transparent',
              pointBackgroundColor: 'rgba(111, 211, 227, 1)',
              pointBorderWidth: 0,

              tension: '0',
              // sells per month
              data: [

                4,
                8,
                6,
                10,
                5,
                7,
                10,

              ],
              fill: false,
            },
            // put new dataset here if needed to show multiple datasets on one graph
          ]
        },
        options: {
          chartArea: {
            backgroundColor: 'rgba(100, 100, 100, 0.02)',
          },
        }
      };

      const canvas = jQuery(this)[0].getContext('2d');
            // tslint:disable-next-line:no-unused-expression
      new Chart(canvas, config);
    });
  } // Monthly visitors


  // Monthly Conversion
  const $canvasesMonthlyConversion = jQuery('.canvas-chart-line-conversions');
  if ($canvasesMonthlyConversion.length) {
    $canvasesMonthlyConversion.each(function(i) {

      const config = {
        type: 'line',
        data: {
          labels: DAYS,
          datasets: [{
            label: 'Conversion',
            backgroundColor: 'rgba(111, 211, 227, 0.6)',
            borderColor: 'rgba(91, 173, 186, 0.5)',
            borderWidth: '2',

            // point options
            pointBorderColor: 'transparent',
            pointBackgroundColor: 'rgba(111, 211, 227, 1)',
            pointBorderWidth: 0,

            // Conversion per month
            data: [

              1.2,
              1.5,
              1.3,
              1.9,
              2,
              2.6,
              2.4,

            ],
            fill: true,
          },
            // put new dataset here if needed to show multiple datasets on one graph
          ]
        },
        options: {
          chartArea: {
            backgroundColor: 'rgba(100, 100, 100, 0.02)',
          },
        }
      };

      const canvas = jQuery(this)[0].getContext('2d');
            // tslint:disable-next-line:no-unused-expression
      new Chart(canvas, config);
    });
  } // Monthly Conversion


  // Monthly Returned Visitors - Not used at the moment
  const $canvasesMonthlyPieVisitors = jQuery('.canvas-chart-pie-visitors');
  if ($canvasesMonthlyPieVisitors.length) {
    $canvasesMonthlyPieVisitors.each(function(i) {

      const config = {
        type: 'pie',
        data: {
          datasets: [{
            data: [
              76,
              24,
            ],
            backgroundColor: [
              'rgba(236, 104, 46, 0.5)',
              'rgba(236, 104, 46, 0.7)'
            ],
            label: 'Monthly Visitors'
          }],
          labels: [
            'New Visitors',
            'Returned Visitors',
          ]
        },
      };

      const canvas = jQuery(this)[0].getContext('2d');
            // tslint:disable-next-line:no-unused-expression
      new Chart(canvas, config);
    });
  } // Monthly Returned Visitors

  // end of Charts

  //////////////
  // vector map//
  //////////////
  // http://jvectormap.com/
  jQuery('.world_map').vectorMap({
    map: 'world_mill',
    backgroundColor: 'transparent',
    zoomOnScroll: false,
    regionsSelectable: true,
    regionsSelectableOne: true,
    markerSelectable: true,
    markerSelectableOne: true,
    regionStyle: {
      initial: {
        fill: '#e9eaeb',
        'fill-opacity': 0.9,
        stroke: 'none',
        'stroke-width': 0,
        'stroke-opacity': 0
      },
      selected: {
        fill: '#eeb269'
      },
    },
    markerStyle: {
      initial: {
        fill: '#dc5753',
        stroke: 'transparent',
        'stroke-width': 0,
      },
      hover: {
        stroke: '#dc5753',
        'stroke-width': 2,
        cursor: 'pointer'
      },
      selected: {
        'fill-opacity': 0.5
      },
      selectedHover: {
      }
    },

    selectedRegions: ['GB'],

    series: {
      regions: [{
        values: {
          AU: 1,
          BR: 2,
          CA: 5,
          CN: 100,
          TR: 1,
          IN: 1,
          GB: 1,
          US: 100,

        },
        scale: ['#007ebd', '#4db19e'],
        normalizeFunction: 'polynomial'
      }]
    },
    markers: [
      {latLng: [41.90, 12.45], name: 'Vatican City'},
      {latLng: [3.2, 73.22], name: 'Maldives'},
    ],
  });

  ///////////////////
  // events calendar//
  ///////////////////
  // https://fullcalendar.io/
  jQuery('.events_calendar').fullCalendar(

    {
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'month,agendaWeek,agendaDay,listWeek'
      },
      defaultDate: '2017-03-12',
      editable: true,
      eventLimit: true, // allow "more" link when too many events
      navLinks: true,
      aspectRatio: 1,
      events: [
        {
          title: 'All Day Event',
          start: '2017-03-01'
        },
        {
          title: 'Long Event',
          start: '2017-03-07',
          end: '2017-03-10'
        },
        {
          id: 999,
          title: 'Repeating Event',
          start: '2017-03-09T16:00:00'
        },
        {
          id: 999,
          title: 'Repeating Event',
          start: '2017-03-16T16:00:00'
        },
        {
          title: 'Conference',
          start: '2017-03-11',
          end: '2017-03-13'
        },
        {
          title: 'Meeting',
          start: '2017-03-12T10:30:00',
          end: '2017-03-12T12:30:00'
        },
        {
          title: 'Lunch',
          start: '2017-03-12T12:00:00'
        },
        {
          title: 'Meeting',
          start: '2017-03-12T14:30:00'
        },
        {
          title: 'Happy Hour',
          start: '2017-03-12T17:30:00'
        },
        {
          title: 'Dinner',
          start: '2017-03-12T20:00:00'
        },
        {
          title: 'Birthday Party',
          start: '2017-03-13T07:00:00'
        },
        {
          title: 'Click for Google',
          url: 'http://google.com/',
          start: '2017-03-28'
        }
      ]
    }

  );

  /////////////////////
  // date range picker//
  /////////////////////
  // http://www.daterangepicker.com/
  function cb(start, end) {
    jQuery('.dashboard-daterangepicker span').html(start.format('MMMM D, YYYY') + ' - ' + end.format('MMMM D, YYYY'));
  }
  (() => {
    const start = moment().subtract(29, 'days');
    const end = moment();

    jQuery('.dashboard-daterangepicker').daterangepicker({
      startDate: start,
      endDate: end,
      autoApply: true,
      linkedCalendars: false,
      showCustomRangeLabel: false,
      alwaysShowCalendars: true,
      ranges: {
        Today: [moment(), moment()],
        Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'Last 7 Days': [moment().subtract(6, 'days'), moment()],
        'Last 30 Days': [moment().subtract(29, 'days'), moment()],
        'This Month': [moment().startOf('month'), moment().endOf('month')],
        'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]

      },
    }, cb);

    cb(start, end);
  })();

  /////////////
  // sparkline//
  /////////////
  // http://omnipotent.net/jquery.sparkline/
  jQuery('.sparklines').each(function() {
    // sparkline type: 'line' (default), 'bar', 'tristate', 'discrete', 'bullet', 'pie', 'box'
    const $this = jQuery(this);
    const data = $this.data();

    const type = data.type ? data.type : 'bar';
    const lineColor = data.lineColor ? data.lineColor : '#4db19e';
    const negBarColor = data.negColor ? data.negColor : '#dc5753';
    const barWidth = data.barWidth ? data.barWidth : 4;
    const height = data.height ? data.height : false;

    const values = data.values ? JSON.parse('[' + data.values + ']') : false;

    $this.sparkline(values, {
      type,
      lineColor,
      barColor: lineColor,
      negBarColor,
      barWidth,
      height,
    });
  });


}

@Injectable()
export class JqueryRunnerService {


  windowLoadInit(isHide?: boolean) {

    /*$('input[type=number]').bind("wheel", function (event) {
      return false;
    });*/

    // To off autocomplete the input
    $('input').attr('autocomplete','none');

    $(document).ready(function() {
      $(window).keydown(function(event){
        if(event.keyCode == 13) {
          event.preventDefault();
          return false;
        }
      });

      /*$('* input').each( function () {
        $(this).get(0).focus();
      });*/

      /*$(input[type='number']).keydown(function(event){
        if(event.keyCode == 13) {
          event.preventDefault();
          return false;
        }
      });*/
    });

    const $boxWrapper = jQuery('#box_wrapper');
    const $sideHeader = jQuery('.page_header_side');

    // initOtherChart();

    if (jQuery().scrollbar) {
      jQuery('[class*="scrollbar-"]').scrollbar();
    }
    if (jQuery().superfish) {
      jQuery('ul.sf-menu').superfish({
        popUpSelector: 'ul:not(.mega-menu ul), .mega-menu ',
        delay:       700,
        animation:   {opacity: 'show', marginTop: 0},
        animationOut: {opacity: 'hide',  marginTop: 5},
        speed:       200,
        speedOut:    200,
        disableHI:   false,
        cssArrows:   true,
        autoArrows:  true

      });
      jQuery('ul.sf-menu-side').superfish({
        popUpSelector: 'ul:not(.mega-menu ul), .mega-menu ',
        delay:       500,
        animation:   {opacity: 'show', height: 100 + '%'},
        animationOut: {opacity: 'hide',  height: 0},
        speed:       400,
        speedOut:    300,
        disableHI:   false,
        cssArrows:   true,
        autoArrows:  true
      });
    }


    jQuery('.toggle_menu').on('click', function() {
      jQuery(this)
        .toggleClass('mobile-active')
        .closest('.page_header')
        .toggleClass('mobile-active')
        .end()
        .closest('.page_toplogo')
        .next()
        .find('.page_header')
        .toggleClass('mobile-active');
    });

    jQuery('.mainmenu a').on('click', function() {
      const $this = jQuery(this);
      if (($this.hasClass('sf-with-ul')) || !($this.attr('href').charAt(0) === '#')) {
        return;
      }
      $this
        .closest('.page_header')
        .toggleClass('mobile-active')
        .find('.toggle_menu')
        .toggleClass('mobile-active');
    });

    jQuery('ul.menu-click').find('li').each(function() {
      const $thisLi = jQuery(this);
      if ($thisLi.find('ul').length)  {
        $thisLi
          .append('<span class="activate_submenu"></span>')
          .find('.activate_submenu, > a')
          .on('click', function(e) {
            const $thisSpanOrA = jQuery(this);
            if (($thisSpanOrA.attr('href') === '#') || !($thisSpanOrA.parent().hasClass('active-submenu'))) {
              e.preventDefault();
            }
            if ($thisSpanOrA.parent().hasClass('active-submenu')) {
              $thisSpanOrA.parent().removeClass('active-submenu');
              return;
            }
            $thisLi.addClass('active-submenu').siblings().removeClass('active-submenu');
          });
      }
    });
    if ($sideHeader.length) {
      jQuery('.toggle_menu_side').on('click', function() {
        const $thisToggler = jQuery(this);
        if ($thisToggler.hasClass('header-slide')) {
          $boxWrapper.toggleClass('sidebar-opened');
          $boxWrapper.toggleClass('sidebar-closed');
          $sideHeader.toggleClass('active-slide-side-header');
          sessionStorage.setItem('slider_class', $sideHeader.hasClass('active-slide-side-header') ? 'active-slide-side-header' : '');
        } else {
          if ($thisToggler.parent().hasClass('header_side_right')) {
            $body.toggleClass('active-side-header slide-right');
          } else {
            $body.toggleClass('active-side-header');
          }
        }
      });
      $body.on('click', (e) => {
        if ( !(jQuery(e.target).closest('.page_header_side').length) && !($sideHeader.hasClass('page_header_side_sticked')) ) {
          $sideHeader.removeClass('active-slide-side-header');
          $body.removeClass('active-side-header slide-right');
        }
      });
    }

    let MainWindowWidth = jQuery(window).width();
    let boxWrapperWidth = jQuery('#box_wrapper').width();
    jQuery(window).on('resize', () => {
      MainWindowWidth = jQuery(window).width();
      boxWrapperWidth = jQuery('#box_wrapper').width();
      if($window.width() < 901) {
        sessionStorage.setItem('slider_class', '');
        $sideHeader.removeClass('active-slide-side-header');
        $boxWrapper.removeClass('sidebar-opened');
        $boxWrapper.addClass('sidebar-closed');
      }
    });
    jQuery('.mainmenu_wrapper .sf-menu').on('mouseover', 'ul li', function() {
      if (MainWindowWidth > 991) {
        const $this = jQuery(this);
        const subMenuExist = $this.find('ul').length;
        if ( subMenuExist > 0) {
          const subMenuWidth = $this.find('ul, div').first().width();
          const subMenuOffset = $this.find('ul, div').first().parent().offset().left + subMenuWidth;
          if ((subMenuOffset + subMenuWidth) > boxWrapperWidth) {
            const newSubMenuPosition = subMenuWidth + 0;
            $this.find('ul, div').first().css({
              left: -newSubMenuPosition,
            });
          } else {
            $this.find('ul, div').first().css({
              left: '100%',
            });
          }
        }
      }
    }).on('mouseover', '> li', function() {
      if (MainWindowWidth > 991) {
        const $this = jQuery(this);
        const subMenuExist = $this.find('ul').length;
        if ( subMenuExist > 0) {
          const subMenuWidth = $this.find('ul').width();
          const subMenuOffset = $this.find('ul').parent().offset().left - (jQuery(window).width() / 2 - boxWrapperWidth / 2);
          if ((subMenuOffset + subMenuWidth) > boxWrapperWidth) {
            const newSubMenuPosition = boxWrapperWidth - (subMenuOffset + subMenuWidth);
            $this.find('ul').first().css({
              left: newSubMenuPosition,
            });
          }
        }
      }
    });

    const navHeight = jQuery('.page_header').outerHeight(true);
    if (jQuery('.mainmenu_side_wrapper').length) {
      $body.scrollspy({
        target: '.mainmenu_side_wrapper',
        offset: navHeight
      });
    } else if (jQuery('.mainmenu_wrapper').length) {
      $body.scrollspy({
        target: '.mainmenu_wrapper',
        offset: navHeight
      });
    }
    if (jQuery().localScroll) {
      jQuery('.mainmenu_wrapper > ul, .mainmenu_side_wrapper > ul, #land').localScroll({
        duration: 900,
        easing: 'easeInOutQuart',
        offset: -navHeight + 40
      });
    }

    jQuery('.bg_teaser, .image_cover').each(function() {
      const $teaser = jQuery(this);
      let $image = $teaser.find('img').first();
      if (!$image.length) {
        $image = $teaser.parent().find('img').first();
      }
      if (!$image.length) {
        return;
      }
      const imagePath = $image.attr('src');
      $teaser.css('background-image', 'url(' + imagePath + ')');
      const $imageParent = $image.parent();
      if ($imageParent.is('a')) {
        $teaser.prepend($image.parent().clone().html(''));
        $imageParent.attr('data-gal', '');
      }
    });

    if (jQuery().UItoTop) {
      jQuery().UItoTop({ easingType: 'easeInOutQuart' });
    }

    if (jQuery().parallax) {
      jQuery('.parallax').parallax('50%', 0.01);
    }

    if (jQuery().prettyPhoto) {
      jQuery('a[data-gal^=\'prettyPhoto\']').prettyPhoto({
        hook: 'data-gal',
        theme: 'facebook',
        social_tools: false
      });
    }

    jQuery('.carousel_filters').find('a').on('click', () => {
      setTimeout(() => {
        jQuery('.filterable-carousel').find('a[data-gal^=\'prettyPhoto\']').prettyPhoto({
          hook: 'data-gal',
          theme: 'facebook',
          social_tools: false
        });
      }, 100);
    });

    if (jQuery().carousel) {
      jQuery('.carousel').carousel();
    }
    jQuery('.nav-tabs').each(function() {
      if(isHide !== true) {
        jQuery(this).find('a').first().tab('show');
      }
    });
    jQuery('.tab-content').each(function() {
      if(isHide !== true) {
        jQuery(this).find('.tab-pane').first().addClass('fade in');
      }
    });
    jQuery('.panel-group').each(function() {
      jQuery(this).find('a').first().filter('.collapsed').trigger('click');
    });
    if (jQuery().tooltip) {
      jQuery('[data-toggle="tooltip"]').tooltip();
    }



    if (jQuery().countdown) {
      const demoDate = new Date();
      demoDate.setMonth(demoDate.getMonth() + 1);
      jQuery('#comingsoon-countdown').countdown({until: demoDate});
    }

    jQuery('form.contact-form').on('submit', function( e ) {
      e.preventDefault();
      const $form = jQuery(this);
      jQuery($form).find('span.contact-form-respond').remove();

      jQuery($form).find('[aria-required="true"], [required]').each(function(index) {
        const $thisRequired = jQuery(this);
        if (!$thisRequired.val().length) {
          $thisRequired
            .addClass('invalid')
            .on('focus', () => {
              $thisRequired
                .removeClass('invalid');
            });
        }
      });
      if ($form.find('[aria-required="true"], [required]').hasClass('invalid')) {
        return;
      }

      const request = $form.serialize();
      const ajax = jQuery.post( 'contact-form.php', request )
        .done( (data) => {
          jQuery($form).find('[type="submit"]').attr('disabled', false).parent()
            .append('<span class="contact-form-respond highlight">' + data + '</span>');
          const $formErrors = $form.find('.form-errors');
          if ( !$formErrors.length ) {
            $form[0].reset();
          }
        })
        .fail( (data) => {
          jQuery($form).find('[type="submit"]').attr('disabled', false).parent()
            .append('<span class="contact-form-respond highlight">Mail cannot be sent. You need MAIL server to send mail.</span>');
        });
    });

    jQuery('.search_modal_button').on('click', (e) => {
      e.preventDefault();
      jQuery('#search_modal').modal('show').find('input').first().focus();
    });
    jQuery('form.searchform').on('submit', function( e ) {

      e.preventDefault();
      const $form = jQuery(this);
      const $searchModal = jQuery('#search_modal');
      $searchModal.find('div.searchform-respond').remove();

      jQuery($form).find('[type="text"]').each(function(index) {
        const $thisField = jQuery(this);
        if (!$thisField.val().length) {
          $thisField
            .addClass('invalid')
            .on('focus', () => {
              $thisField.removeClass('invalid');
            });
        }
      });
      if ($form.find('[type="text"]').hasClass('invalid')) {
        return;
      }

      $searchModal.modal('show');
      const request = $form.serialize();
      const ajax = jQuery.post( 'search.php', request )
        .done( (data) => {
          $searchModal.append('<div class="searchform-respond">' + data + '</div>');
        })
        .fail( (data) => {
          $searchModal.append('<div class="searchform-respond">Search cannot be done. You need PHP server to search.</div>');
        });
    });

    jQuery('.signup').on('submit', function( e ) {
      e.preventDefault();
      const $form = jQuery(this);
      $form.find('.response').html('Adding email address...');
      jQuery.ajax({
        url: 'mailchimp/store-address.php',
        data: 'ajax=true&email=' + escape($form.find('.mailchimp_email').val()),
        success(msg) {
          $form.find('.response').html(msg);
        }
      });
    });

    if (jQuery().tweet) {
      jQuery('.twitter').tweet({
        modpath: './twitter/',
        count: 2,
        avatar_size: 48,
        loading_text: 'loading twitter feed...',
        join_text: 'auto',
        username: 'michaeljackson',
        template: '{avatar}<div class="tweet_right">{time}{join}<span class="tweet_text">{tweet_text}</span></div>'
      });
    }


    jQuery('#mainteasers .col-lg-4').addWidthClass({
      breakpoints: [500, 600]
    });

    const $timetable = jQuery('#timetable');
    if ($timetable.length) {
      jQuery('#timetable_filter').on( 'click', 'a', function( e ) {
        e.preventDefault();
        e.stopPropagation();
        const $thisA = jQuery(this);
        if ( $thisA.hasClass('selected') ) {
          return;
        }
        const selector = $thisA.attr('data-filter');
        $timetable
          .find('tbody td')
          .removeClass('current')
          .end()
          .find(selector)
          .closest('td')
          .addClass('current');
        $thisA.closest('ul').find('a').removeClass('selected');
        $thisA.addClass('selected');
      });
    }

    jQuery('#toggle_shop_view').on('click', function( e ) {
      e.preventDefault();
      jQuery(this).toggleClass('grid-view');
      jQuery('#products').toggleClass('grid-view list-view');
    });
    if (jQuery().elevateZoom) {
      jQuery('#product-image').elevateZoom({
        gallery: 'product-image-gallery',
        cursor: 'pointer',
        galleryActiveClass: 'active',
        responsive: true,
        loadingIcon: 'img/AjaxLoader.gif'
      });
    }

    jQuery('.review-link').on('click', function( e ) {
      const $thisLink = jQuery(this);
      const reviewTabLink = jQuery('a[href="#reviews_tab"]');
      if (!reviewTabLink.parent().hasClass('active')) {
        reviewTabLink
          .tab('show')
          .on('shown.bs.tab', (e1) => {
            $window.scrollTo($thisLink.attr('href'), 400);
          });
      }
      $window.scrollTo($thisLink.attr('href'), 400);
    });

    jQuery('.plus, .minus').on('click', function( e ) {
      const numberField = jQuery(this).parent().find('[type="number"]');
      const currentVal = numberField.val();
      const sign = jQuery(this).val();
      if (sign === '-') {
        if (currentVal > 1) {
          numberField.val(parseFloat(currentVal) - 1);
        }
      } else {
        numberField.val(parseFloat(currentVal) + 1);
      }
    });

    jQuery('a.remove').on('click', function( e ) {
      e.preventDefault();
      jQuery(this).closest('tr, .media').remove();
    });

    if (jQuery().slider) {
      const $rangeSlider = jQuery('.slider-range-price');
      if ($rangeSlider.length) {

        const $priceMin = jQuery('.slider_price_min');
        const $priceMax = jQuery('.slider_price_max');
        const $priceMinLabel = jQuery('.slider_price_min_label');
        const $priceMaxLabel = jQuery('.slider_price_max_label');
        $rangeSlider.slider({
          range: true,
          min: 0,
          max: 250,
          values: [30, 100],
          slide(event, ui) {
            $priceMin.val(ui.values[0]);
            $priceMinLabel.text(ui.values[0]);
            $priceMax.val(ui.values[1]);
            $priceMaxLabel.text(ui.values[1]);
          }
        });
        $priceMin.val($rangeSlider.slider('values', 0));
        $priceMinLabel.text($rangeSlider.slider('values', 0));
        $priceMax.val($rangeSlider.slider('values', 1));
        $priceMaxLabel.text($rangeSlider.slider('values', 1));
      }
    }
    jQuery('.color-filters').find('a[data-background-color]').each(function() {
      jQuery(this).css({'background-color' : jQuery(this).data('background-color')});
    });

    if (jQuery().flexslider) {
      const $introSlider = jQuery('.intro_section .flexslider');
      $introSlider.each(function(index) {
        const $currentSlider = jQuery(this);
        const data = $currentSlider.data();
        const nav = (data.nav !== 'undefined') ? data.nav : true;
        const dots = (data.dots !== 'undefined') ? data.dots : true;

        $currentSlider.flexslider({
          animation: 'slide',
          direction: 'vertical',
          pauseOnHover: true,
          useCSS: true,
          controlNav: dots,
          directionNav: nav,
          prevText: '',
          nextText: '',
          smoothHeight: false,
          slideshowSpeed: 10000,
          animationSpeed: 600,
          start( slider ) {
            slider.find('.slide_description').children().css({visibility: 'hidden'});
            slider.find('.flex-active-slide .slide_description').children().each(function(index1) {
              const self = jQuery(this);
              const animationClass = !self.data('animation') ? 'fadeInRight' : self.data('animation');
              setTimeout(() => {
                self.addClass('animated ' + animationClass);
              }, index1 * 200);
            });
          },
          after( slider ) {
            slider.find('.flex-active-slide .slide_description').children().each((index2) => {
              const self = jQuery(this);
              const animationClass = !self.data('animation') ? 'fadeInRight' : self.data('animation');
              setTimeout(() => {
                self.addClass('animated ' + animationClass);
              }, index2 * 200);
            });
          },
          end( slider ) {
            slider.find('.slide_description').children().each(function() {
              const self = jQuery(this);
              const animationClass = !self.data('animation') ? 'fadeInRight' : self.data('animation');
              self.removeClass('animated ' + animationClass).css({visibility: 'hidden'});
            });
          },

        })
          .find('.flex-control-nav')
          .wrap('<div class="container nav-container"/>');
      });

      jQuery('.flexslider').each(function(index) {
        const $currentSlider = jQuery(this);
        if ($currentSlider.find('.flex-active-slide').length) {
          return;
        }
        $currentSlider.flexslider({
          animation: 'fade',
          useCSS: true,
          controlNav: true,
          directionNav: false,
          prevText: '',
          nextText: '',
          smoothHeight: false,
          slideshowSpeed: 5000,
          animationSpeed: 800,
        });
      });
    }

    const $header = jQuery('.page_header').first();
    const $side_header_logo = jQuery('.side_header_logo');
    const boxed = $header.closest('.boxed').length;
    if ($header.length) {
      menuHideExtraElements();
      initMegaMenu();
      const headerHeight = $header.outerHeight();
      $header.wrap('<div class="page_header_wrapper"></div>');
      const $headerWrapper = $header.parent();
      if (!boxed) {
        $headerWrapper.css({height: headerHeight});
        $side_header_logo.css({height: headerHeight});
        // $headerWrapper.css({height: 70});
      }

      if ( $header.hasClass('header_white') ) {
        $headerWrapper.addClass('header_white');
      } else if ( $header.hasClass('header_darkgrey') ) {
        $headerWrapper.addClass('header_darkgrey');
        if ( $header.hasClass('bs') ) {
          $headerWrapper.addClass('bs');
        }

      } else if ( $header.hasClass('header_gradient') ) {
        $headerWrapper.addClass('header_gradient');
      }

      let headerOffset = 0;
      if (!boxed && !($headerWrapper.css('position') === 'fixed')) {
        headerOffset = $header.offset().top;
      }

      jQuery($header).on('affixed-top.bs.affix affixed.bs.affix affixed-bottom.bs.affix', (e) => {
        if ( $header.hasClass('affix-top') ) {
          $headerWrapper.removeClass('affix-wrapper affix-bottom-wrapper').addClass('affix-top-wrapper');
        } else if ( $header.hasClass('affix') ) {
          $headerWrapper.removeClass('affix-top-wrapper affix-bottom-wrapper').addClass('affix-wrapper');
        } else if ( $header.hasClass('affix-bottom') ) {
          $headerWrapper.removeClass('affix-wrapper affix-top-wrapper').addClass('affix-bottom-wrapper');
        } else {
          $headerWrapper.removeClass('affix-wrapper affix-top-wrapper affix-bottom-wrapper');
        }
        menuHideExtraElements();
        initMegaMenu();
      });

      jQuery($header).on('affixed-top.bs.affix', () => {
        // $headerWrapper.css({height: $header.outerHeight()});
      });

      jQuery($header).affix({
        offset: {
          top: headerOffset,
          bottom: 0
        }
      });
    }

    if (jQuery().owlCarousel) {
      jQuery('.owl-carousel').each(function() {
        const $carousel = jQuery(this);
        const data = $carousel.data();

        const loop = data.loop ? data.loop : false;
        const margin = (data.margin || data.margin === 0) ? data.margin : 30;
        const nav = data.nav ? data.nav : false;
        const dots = data.dots ? data.dots : false;
        const themeClass = data.themeclass ? data.themeclass : 'owl-theme';
        const center = data.center ? data.center : false;
        const items = data.items ? data.items : 4;
        const autoplay = data.autoplay ? data.autoplay : false;
        const responsiveXs = data.responsiveXs ? data.responsiveXs : 1;
        const responsiveSm = data.responsiveSm ? data.responsiveSm : 2;
        const responsiveMd = data.responsiveMd ? data.responsiveMd : 3;
        const responsiveLg = data.responsiveLg ? data.responsiveLg : 4;
        const filters = data.filters ? data.filters : false;

        if (filters) {
          $carousel.clone().appendTo($carousel.parent()).addClass( filters.substring(1) + '-carousel-original' );
          jQuery(filters).on('click', 'a', function( e ) {
            e.preventDefault();
            const $thisA = jQuery(this);
            if ($thisA.hasClass('selected')) {
              return;
            }
            const filterValue = $thisA.attr('data-filter');
            $thisA.siblings().removeClass('selected active');
            $thisA.addClass('selected active');

            for (let i = $carousel.find('.owl-item').length - 1; i >= 0; i--) {
              $carousel.trigger('remove.owl.carousel', [1]);
            }

            const $filteredItems = jQuery($carousel.next().find(' > ' + filterValue).clone());
            $filteredItems.each(function() {
              $carousel.trigger('add.owl.carousel', jQuery(this));

            });

            $carousel.trigger('refresh.owl.carousel');
          });

        }

        $carousel.owlCarousel({
          loop,
          margin,
          nav,
          autoplay,
          dots,
          themeClass,
          center,
          items,
          responsive: {
            0: {
              items: responsiveXs
            },
            767: {
              items: responsiveSm
            },
            992: {
              items: responsiveMd
            },
            1200: {
              items: responsiveLg
            }
          },
        })
          .addClass(themeClass);
        if (center) {
          $carousel.addClass('owl-center');
        }

        $window.on('resize', () => {
          $carousel.trigger('refresh.owl.carousel');
        });
      });

    }

    affixSidebarInit();

    $body.scrollspy('refresh');

    if (jQuery().appear) {
      jQuery('.to_animate').appear();

      jQuery('.to_animate').filter(':appeared').each(function(index) {
        initAnimateElement(jQuery(this), index);
      });

      $body.on('appear', '.to_animate', (e, $affected ) => {
        jQuery($affected).each(function(index) {
          initAnimateElement(jQuery(this), index);
        });
      });

      if (jQuery().countTo) {
        jQuery('.counter').appear();

        jQuery('.counter').filter(':appeared').each(function() {
          initCounter(jQuery(this));
        });
        $body.on('appear', '.counter', (e, $affected ) => {
          jQuery($affected).each(function() {
            initCounter(jQuery(this));
          });
        });
      }

      if (jQuery().progressbar) {
        jQuery('.progress .progress-bar').appear();

        jQuery('.progress .progress-bar').filter(':appeared').each(function() {
          initProgressbar(jQuery(this));
        });
        $body.on('appear', '.progress .progress-bar', (e, $affected ) => {
          jQuery($affected).each(function() {
            initProgressbar(jQuery(this));
          });
        });
        jQuery('a[data-toggle="tab"]').on('shown.bs.tab', function(e) {
          initProgressbar(jQuery(jQuery(e.target).attr('href')).find('.progress .progress-bar'));
        });
        jQuery('.dropdown').on('shown.bs.dropdown', function(e) {
          initProgressbar(jQuery(this).find('.progress .progress-bar'));
        });
      }

      if (jQuery().easyPieChart) {

        jQuery('.chart').appear();

        jQuery('.chart').filter(':appeared').each(function() {
          initChart(jQuery(this));
        });
        $body.on('appear', '.chart', (e, $affected ) => {
          jQuery($affected).each(function() {
            initChart(jQuery(this));
          });
        });

      }

    }

    if (jQuery().jflickrfeed) {
      const $flickr = jQuery('#flickr, .flickr_ul');
      if ( $flickr.length ) {
        if ( ! ( $flickr.hasClass('flickr_loaded') ) ) {
          $flickr.jflickrfeed({
            flickrbase: 'http://api.flickr.com/services/feeds/',
            limit: 4,
            qstrings: {
              id: '131791558@N04'
            },
            itemTemplate: '<a href="{{image_b}}" data-gal="prettyPhoto[pp_gal]"><li><img alt="{{title}}" src="{{image_m}}" /></li></a>'
          }, (data) => {
            $flickr.find('a').prettyPhoto({
              hook: 'data-gal',
              theme: 'facebook'
            });
          }).addClass('flickr_loaded');
        }
      }
    }

    if (jQuery().spectragram) {
      const Spectra = {
        instaToken: '3905738328.60c782d.b65ed3f058d64e6ab32c110c6ac12d9b',
        instaID: '60c782dfecaf4050b59ff4c159246641',

        init() {
          jQuery.fn.spectragram.accessData = {
            accessToken: this.instaToken,
            clientID: this.instaID
          };

          jQuery('.instafeed').each(function() {
            const $this = jQuery(this);
            if ($this.find('img').length) {
              return;
            }
            $this.spectragram('getRecentTagged', {
              max: 8,
              query: 'grey',
              wrapEachWith: '<div class="photo">'
            });
          });
        }
      };

      Spectra.init();
    }

    jQuery('.embed-placeholder').each(function() {
      jQuery(this).on('click', function(e) {
        const $thisLink = jQuery(this);
        if ($thisLink.attr('data-gal')) {
          return;
        }
        e.preventDefault();
        if ($thisLink.attr('href') === '' || $thisLink.attr('href') === '#') {
          $thisLink.replaceWith($thisLink.data('iframe').replace(/&amp/g, '&').replace(/$lt;/g, '<')
            .replace(/&gt;/g, '>').replace(/$quot;/g, '"')).trigger('click');
        } else {
          $thisLink.replaceWith('<iframe class="embed-responsive-item" src="'
            + $thisLink.attr('href') + '?rel=0&autoplay=1' + '"></iframe>');
        }
      });
    });

    jQuery('.isotope_container').each(function(index) {
      const $container = jQuery(this);
      const layoutMode = ($container.hasClass('masonry-layout')) ? 'masonry' : 'fitRows';
      const columnWidth = ($container.find('.col-lg-20').length) ? '.col-lg-20' : '';
      $container.isotope({
        percentPosition: true,
        layoutMode,
        masonry: {
          columnWidth
        }
      });

      const $filters = jQuery(this).attr('data-filters') ? jQuery(jQuery(this).attr('data-filters')) : $container.prev().find('.filters');
      if ($filters.length) {
        $filters.on( 'click', 'a', function( e ) {
          e.preventDefault();
          const $thisA = jQuery(this);
          const filterValue = $thisA.attr('data-filter');
          $container.isotope({ filter: filterValue });
          $thisA.siblings().removeClass('selected active');
          $thisA.addClass('selected active');
        });
        $filters.on( 'change', 'select', function( e ) {
          e.preventDefault();
          const filterValue = jQuery(this).val();
          $container.isotope({ filter: filterValue });
        });
      }
    });

    const $messagesModal = jQuery('#messages_modal');
    if ($messagesModal.find('ul').length) {
      $messagesModal.modal('show');
    }

    jQuery('.preloaderimg').fadeOut(150);
    jQuery('.preloader').fadeOut(350).delay(200, function() {
      // jQuery(this).remove();
    });
  }

  windowMethod() {
    $window.on('load', () => {
      this.windowLoadInit();

      jQuery('.choice').on('change', () => {
        if (jQuery(this).val() === '') { jQuery(this).addClass('empty'); } else { jQuery(this).removeClass('empty'); }
      });
    });

    $window.on('resize', () => {

      $body.scrollspy('refresh');

      menuHideExtraElements();
      initMegaMenu();
      const $header = jQuery('.page_header').first();
      if ($header.length && !jQuery(document).scrollTop() && $header.first().data('bs.affix')) {
        $header.first().data('bs.affix').options.offset.top = $header.offset().top;
      }
      if (!$header.closest('.boxed').length) {
        jQuery('.page_header_wrapper').css({height: $header.first().outerHeight()});
      }

    });

  }

  loadLoginPage() {
    if (jQuery().appear) {
      jQuery('.to_animate').appear();

      jQuery('.to_animate').filter(':appeared').each(function(index) {
        initAnimateElement(jQuery(this), index);
      });

      $body.on('appear', '.to_animate', (e, $affected ) => {
        jQuery($affected).each(function(index) {
          initAnimateElement(jQuery(this), index);
        });
      });

      if (jQuery().countTo) {
        jQuery('.counter').appear();

        jQuery('.counter').filter(':appeared').each(function() {
          initCounter(jQuery(this));
        });
        $body.on('appear', '.counter', (e, $affected ) => {
          jQuery($affected).each(function() {
            initCounter(jQuery(this));
          });
        });
      }

      if (jQuery().progressbar) {
        jQuery('.progress .progress-bar').appear();

        jQuery('.progress .progress-bar').filter(':appeared').each(function() {
          initProgressbar(jQuery(this));
        });
        $body.on('appear', '.progress .progress-bar', (e, $affected ) => {
          jQuery($affected).each(function() {
            initProgressbar(jQuery(this));
          });
        });
        jQuery('a[data-toggle="tab"]').on('shown.bs.tab', function(e) {
          initProgressbar(jQuery(jQuery(e.target).attr('href')).find('.progress .progress-bar'));
        });
        jQuery('.dropdown').on('shown.bs.dropdown', function(e) {
          initProgressbar(jQuery(this).find('.progress .progress-bar'));
        });
      }

      if (jQuery().easyPieChart) {

        jQuery('.chart').appear();

        jQuery('.chart').filter(':appeared').each(function() {
          initChart(jQuery(this));
        });
        $body.on('appear', '.chart', (e, $affected ) => {
          jQuery($affected).each(function() {
            initChart(jQuery(this));
          });
        });

      }

    }
  }
}


/*Commented Line 811 */
